import React, { useEffect, useRef, useState } from 'react';
import './Hero.css';

function CountUp({ end, duration = 2000 }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const startTime = performance.now();
          const step = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            setCount(Math.floor(progress * end));
            if (progress < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [end, duration]);

  return <span ref={ref}>{count}</span>;
}

const stats = [
  { value: 500, suffix: '+', label: 'Students' },
  { value: 15, suffix: '+', label: 'Years Experience' },
  { value: 95, suffix: '%', label: 'Success Rate' },
  { value: 10, suffix: '+', label: 'Expert Teachers' },
];

export default function Hero() {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="hero">
      <div className="hero__overlay"></div>
      <div className="hero__content">
        <div className="hero__badge">🏆 India's Trusted Tuition Centre</div>
        <h1 className="hero__title">
          Shape Your Future With<br />
          <span className="hero__title-accent">Triumph Classes</span>
        </h1>
        <p className="hero__subtitle">
          Expert coaching in Maths, Science, English, SST, Computers, Hindi &amp; Sanskrit.
          Small batches, personalized attention, proven results — in Nehru Nagar, Ghaziabad.
        </p>
        <div className="hero__actions">
          <button className="hero__btn hero__btn--primary" onClick={() => scrollTo('courses')}>
            Explore Courses
          </button>
          <button className="hero__btn hero__btn--secondary" onClick={() => scrollTo('contact')}>
            Contact Us
          </button>
        </div>
      </div>
      <div className="hero__stats">
        {stats.map((stat) => (
          <div className="hero__stat" key={stat.label}>
            <div className="hero__stat-value">
              <CountUp end={stat.value} />{stat.suffix}
            </div>
            <div className="hero__stat-label">{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
